import { queryClient } from "@/lib/queryClient";
import { clearOnboardingStorage } from "@/features/onboarding/onboardingStorage";

/** Per-user portfolio blobs in sessionStorage (keyed by firebase uid). */
export function clearPortfolioSessionCache(): void {
  try {
    Object.keys(sessionStorage).forEach((k) => {
      if (k.startsWith("portfolioCache_")) sessionStorage.removeItem(k);
    });
  } catch {
    /* ignore */
  }
}

const USER_LOCAL_KEYS = [
  "connected_broker",
  "selected_strategy_name",
  "onboarding_status_cache",
  "broker_status_cache",
] as const;

/** localStorage keys that are not namespaced by user but must not bleed across accounts. */
export function clearUserLocalPreferences(): void {
  clearOnboardingStorage();
  for (const key of USER_LOCAL_KEYS) {
    localStorage.removeItem(key);
  }
}

/** Drop all in-memory query cache and browser session data for the active user. */
export function clearUserScopedCaches(): void {
  clearPortfolioSessionCache();
  clearUserLocalPreferences();
  queryClient.clear();
}
